<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const fadeOut = ref(false);
const redirectLocation = ref("Dashboard");
const user = ref([])

onMounted(() => {

  user.value =  JSON.parse(localStorage.getItem("user"));

  if (user.value.role === "admin") {
    redirectLocation.value = "Dashboard";
  } else {
    redirectLocation.value = "New Trip Page";
  }

  setTimeout(() => {
    fadeOut.value = true;
    setTimeout(() => {
      // Obtener el rol del usuario del local storage
      if(user.value.role === "admin") {
        router.push("/dashboard");
      } else {
        router.push("/user/trips/create");
      }
    }, 800); // Tiempo para la transición
  }, 2000);
});
</script>

<template>
  <div
      class="fixed inset-0 flex justify-center items-center bg-gray-100 dark:bg-gray-900 transition-opacity duration-700"
      :class="{ 'opacity-0': fadeOut }"
  >
    <div class="relative flex flex-col items-center">
      <!-- Spinner con animación -->
      <div class="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

      <!-- Texto animado -->
      <h1 class="mt-4 text-xl font-semibold text-gray-700 dark:text-gray-300 animate-pulse">
        Preparing {{redirectLocation}}...
      </h1>
    </div>
  </div>
</template>

<style scoped>
/* Animación para desvanecer */
.opacity-0 {
  opacity: 0;
}
</style>
